"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Container_1 = __importDefault(require("../../../../layouts/Container"));
const Inline_1 = __importDefault(require("../../../../layouts/Inline"));
const Stack_1 = __importDefault(require("../../../../layouts/Stack"));
const Box_1 = __importDefault(require("../../../../layouts/Box"));
const Button_1 = __importDefault(require("../../../Button"));
const StepNavigation_1 = __importDefault(require("../StepNavigation"));
const Step_1 = __importDefault(require("../Step"));
const WizardInner = ({ step, stepsInfo, stepCount, activeStepIndex, maxStepIndex, getStepNumberLabel = (stepNumber) => `Step ${stepNumber}`, cancelButtonText = 'Cancel', previousButtonText = 'Previous', nextButtonText = 'Next', submitButtonText = 'Submit', optionalText = 'optional', isLoadingNextStep = false, disableStepNavigation = false, onNextButtonClick, onPreviousButtonClick, onStepNavigationClick, onSubmitButtonClick, onCancelButtonClick, }) => {
    const actions = react_1.useMemo(() => {
        return (react_1.default.createElement(Inline_1.default, null,
            react_1.default.createElement(Button_1.default, { variant: "link", onClick: onCancelButtonClick }, cancelButtonText),
            activeStepIndex === 0 ? (react_1.default.createElement(Button_1.default, { variant: "primary", loading: isLoadingNextStep, onClick: onNextButtonClick }, nextButtonText)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Button_1.default, { variant: "normal", onClick: onPreviousButtonClick }, previousButtonText),
                react_1.default.createElement(Button_1.default, { variant: "primary", loading: isLoadingNextStep, onClick: activeStepIndex === stepCount - 1 ? onSubmitButtonClick : onNextButtonClick }, activeStepIndex === stepCount - 1 ? submitButtonText : nextButtonText)))));
    }, [
        activeStepIndex,
        stepCount,
        isLoadingNextStep,
        cancelButtonText,
        nextButtonText,
        previousButtonText,
        submitButtonText,
        onCancelButtonClick,
        onNextButtonClick,
        onPreviousButtonClick,
        onSubmitButtonClick,
    ]);
    return (react_1.default.createElement(Container_1.default, null,
        react_1.default.createElement(Box_1.default, { display: "flex" },
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Box_1.default, { mr: 8 },
                    react_1.default.createElement(StepNavigation_1.default, { disableStepNavigation: disableStepNavigation, steps: stepsInfo, getStepNumberLabel: getStepNumberLabel, activeStepIndex: activeStepIndex, maxStepIndex: maxStepIndex, optionalText: optionalText, onStepNavigationClick: onStepNavigationClick }))),
            react_1.default.createElement(Box_1.default, { flexGrow: 1 },
                react_1.default.createElement(Stack_1.default, null,
                    react_1.default.createElement(Box_1.default, null,
                        react_1.default.createElement(Step_1.default, { step: step })),
                    react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "flex-end" }, actions))))));
};
exports.default = WizardInner;
//# sourceMappingURL=index.js.map